import React, { useEffect, useState } from 'react';
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMyContext } from '../../../../context/MyContext';

import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import '../../../../css/custom-scrollbar.css';
import { Base_Url, ratecardList } from '../../../../config/config';
import { FcMoneyTransfer } from "react-icons/fc";
import { MdLocationCity, MdOutlineMap, MdApartment, MdPublic, MdTerrain, MdOutlinePayments } from "react-icons/md";
import { toast } from 'react-toastify';


const RateCard = () => {
  const { isDarkMode } = useMyContext();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { isToggleSidebar } = useMyContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const itemsPerPage = 8;
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [currentTab, setCurrentTab] = useState('surface');
  useEffect(() => {
    fetchRateCardList()
  }, [])

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleNavigation = () => {
    navigate('/dashboard');
  };


  const fetchRateCardList = async () => {
    try {
      const url = Base_Url + ratecardList

      const response = await fetch(url +"/" + cus_id, {
        method: 'GET',
        headers: {
          token: token || '',
          cus_id: cus_id || '',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch data');
      }

      const result = await response.json();

      if (result && result.data) {
        setData(result.data);
      } else {
        console.error('Unexpected response structure:', result);
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
      console.error('API error:', error.message);
      toast.error('Error fetching order data: ' + error.message);
    }
  };

  const accents = [
    { grad: 'from-blue-500 to-cyan-400', soft: 'bg-blue-50 dark:bg-blue-900/20', text: 'text-blue-600 dark:text-blue-400' },
    { grad: 'from-customPurple to-purple-500', soft: 'bg-purple-50 dark:bg-purple-900/20', text: 'text-customPurple dark:text-purple-300' },
    { grad: 'from-emerald-500 to-green-400', soft: 'bg-emerald-50 dark:bg-emerald-900/20', text: 'text-emerald-600 dark:text-emerald-400' },
    { grad: 'from-orange-500 to-amber-400', soft: 'bg-orange-50 dark:bg-orange-900/20', text: 'text-orange-600 dark:text-orange-400' },
    { grad: 'from-indigo-500 to-blue-400', soft: 'bg-indigo-50 dark:bg-indigo-900/20', text: 'text-indigo-600 dark:text-indigo-400' },
  ];

  const zoneIcons = {
    A: MdLocationCity,
    B: MdOutlineMap,
    C: MdApartment,
    D: MdPublic,
    E: MdTerrain,
  };

  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className="z-10">
          <NavBar />
        </div>

        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
              style={
                window.innerWidth < 768
                  ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                  : {}
              }>
              <Sidebar />
            </div>
          )}
          <div className={`relative bg-gray-100  w-full rounded-custom custom-scrollbar overflow-y-auto dark:shadow-custom-dark p-4 md:p-6 ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : ''}`}>

            {/* Ambient background */}
            <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-custom">
              <div className="absolute -top-24 -left-24 w-72 h-72 bg-customPurple/10 rounded-full blur-3xl"></div>
              <div className="absolute top-1/2 -right-16 w-72 h-72 bg-blue-400/10 rounded-full blur-3xl"></div>
            </div>

            <div className="relative">
              {/* Header */}
              <div className="flex items-center justify-between gap-3 mb-6 animate-fade-in">
                <div className="flex items-center gap-3">
                  <div className="relative shrink-0">
                    <div className="absolute -inset-1.5 bg-customPurple/20 rounded-2xl blur-md"></div>
                    <div className="relative w-11 h-11 flex items-center justify-center rounded-2xl bg-gradient-to-br from-customPurple to-purple-600 shadow-lg">
                      <FcMoneyTransfer size={22} />
                    </div>
                  </div>
                  <div>
                    <h1 className="text-lg md:text-2xl font-black tracking-tight bg-gradient-to-r from-customPurple to-blue-500 bg-clip-text text-transparent">
                      Rate Card
                    </h1>
                    <p className="text-xs md:text-sm text-gray-500 dark:text-gray-400">
                      Zone-wise shipping rates across your courier partners
                    </p>
                  </div>
                </div>

                <button
                  onClick={handleNavigation}
                  className="shrink-0 text-sm font-semibold bg-gradient-to-r from-customPurple to-purple-600 hover:opacity-90 hover:shadow-lg hover:shadow-customPurple/30 text-white px-4 py-2.5 rounded-xl transition-all"
                >
                  Back to Dashboard
                </button>
              </div>

              {/* Content */}
              {data.length === 0 ? (
                <div className="flex flex-col items-center justify-center text-center py-20 bg-white dark:bg-darkmodeColor rounded-2xl shadow-xl ring-1 ring-black/5 dark:ring-white/10">
                  <div className="w-16 h-16 rounded-full bg-purple-50 dark:bg-purple-900/20 flex items-center justify-center mb-4">
                    <FcMoneyTransfer size={28} />
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-gray-500 dark:text-gray-400">Loading your rate card</h3>
                  <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">Rates will appear here once fetched.</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                  {Array.from(new Set(data.map(item => item.partner))).map((partner, index) => {
                    const zoneA = data.find(item => item.partner === partner && item.zone_name === 'A');
                    const zoneB = data.find(item => item.partner === partner && item.zone_name === 'B');
                    const zoneC = data.find(item => item.partner === partner && item.zone_name === 'C');
                    const zoneD = data.find(item => item.partner === partner && item.zone_name === 'D');
                    const zoneE = data.find(item => item.partner === partner && item.zone_name === 'E');

                    const zones = [
                      { key: 'A', label: 'Within City', data: zoneA },
                      { key: 'B', label: 'Within State', data: zoneB },
                      { key: 'C', label: 'Metro', data: zoneC },
                      { key: 'D', label: 'Rest of India', data: zoneD },
                      { key: 'E', label: 'J&K, NorthEast', data: zoneE },
                    ];

                    const accent = accents[index % accents.length];

                    return (
                      <div
                        key={partner}
                        className="bg-white dark:bg-darkmodeColor rounded-2xl shadow-xl ring-1 ring-black/5 dark:ring-white/10 overflow-hidden animate-fade-in"
                        style={{ animationDelay: `${index * 80}ms` }}
                      >
                        {/* Partner header */}
                        <div className={`bg-gradient-to-r ${accent.grad} px-5 py-4 flex items-center justify-between`}>
                          <h2 className="text-base font-bold text-white capitalize">{partner}</h2>
                          <div className="flex items-center gap-1.5 bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full">
                            <MdOutlinePayments className="w-3.5 h-3.5 text-white" />
                            <span className="text-[11px] font-semibold text-white">
                              COD {zoneA?.cod_percentage || '-'}% · Min ₹{zoneA?.min_cod_price || '-'}
                            </span>
                          </div>
                        </div>

                        {/* Zone grid */}
                        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                          {zones.map((zone) => {
                            const ZoneIcon = zoneIcons[zone.key];
                            return (
                              <div key={zone.key} className={`rounded-xl p-3 ${accent.soft}`}>
                                <div className="flex items-center gap-1.5 mb-2">
                                  <ZoneIcon className={`w-3.5 h-3.5 ${accent.text}`} />
                                  <span className="text-[11px] font-bold uppercase tracking-wide text-gray-500 dark:text-gray-400">
                                    {zone.label}
                                  </span>
                                </div>
                                <div className="flex items-baseline gap-2 mb-0.5">
                                  <span className={`text-sm font-bold ${accent.text}`}>₹{zone.data?.express_price || '-'}</span>
                                  <span className="text-[10px] text-gray-400 dark:text-gray-500">Express</span>
                                </div>
                                <div className="flex items-baseline gap-2 mb-2">
                                  <span className="text-sm font-semibold text-gray-700 dark:text-gray-200">₹{zone.data?.surface_price || '-'}</span>
                                  <span className="text-[10px] text-gray-400 dark:text-gray-500">Surface</span>
                                </div>
                                <div className="text-[10px] text-gray-500 dark:text-gray-400 leading-relaxed">
                                  +₹{zone.data?.additional_expressprice_per500gm || '-'} / 500g express<br />
                                  +₹{zone.data?.additional_surfaceprice_per500gm || '-'} / 500g surface
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.5s ease-out both;
        }
      `}</style>
    </>
  );
};

export default RateCard;